import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '../../utils/api.service';
import { Question, QuestionGroup } from '../../models/satisfaction';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class QuestionGroupService {

  path = 'question_groups';
  constructor(
    private api: ApiService,
  ) {
  }

  get(id: string, lang: string = ''): Observable<QuestionGroup> {
    return this.api.get(`${this.path}/${id}`, new HttpParams(), lang);
  }

  getAll(): Observable<QuestionGroup[]> {
    return this.api.get(this.path);
  }

  getQuestions(id: string, lang: string = ''): Observable<Question[]> {
    return this.api.get(`${this.path}/${id}/questions`, new HttpParams(), lang);
  }

  save(questionGroup, lang: string = ''): Observable<QuestionGroup> {
    if (questionGroup.id) {
      return this.api.put(`${this.path}/${questionGroup.id}`, questionGroup, lang);
    } else {
      return this.api.post(this.path, questionGroup, lang);
    }
  }
}
